var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M28.2 5.2L17.4 16l10.8 10.8-1.4 1.4L16 17.4 5.2 28.2l-1.4-1.4L14.6 16 3.8 5.2l1.4-1.4L16 14.6 26.8 3.8"})));
}

Close.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Close;

Close.default = Close;
